import { Box, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import { ReactFitty } from 'react-fitty';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import TelegramIcon from '@mui/icons-material/Telegram';
import GitHubIcon from '@mui/icons-material/GitHub';

const Last = () => {
  return (
    <Box height={"100dvh"} sx={{
      backgroundColor: '#e5e8d9',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '100px 0',
      '@media screen and (max-width: 600px)': {
        padding: '10px',
      }
    }}>
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <KeyboardDoubleArrowDownIcon sx={{ color: '#fd4002', fontSize: '4rem' }} />
      </Box>
      <Box>
        <Box sx={{
          padding: '100px 100px 0 100px',
          '@media screen and (max-width: 600px)': {
            padding: '10px',
          }
        }}>
          <Typography
            sx={{
              textAlign: 'center',
              position: 'relative',
              zIndex: 1,
              lineHeight: 0.7,
              color: '#fd4002'
            }}
            component={ReactFitty}
          >
            LET'S WORK
          </Typography>
          <Typography
            color='secondary'
            sx={{
              fontFamily: "Great Vibes",
              textAlign: 'center',
              position: 'relative',
              zIndex: 3,
              width: '100%',
              fontSize: '8rem',
              padding: '0 30px',
              marginTop: '-120px',
              lineHeight: 0.7,
              '@media screen and (max-width: 600px)': {
                fontSize: '5rem',
                marginTop: '-60px',
              },
              '@media screen and (min-width: 601px) and (max-width: 900px)': {
                fontSize: '6rem',
                marginTop: '-70px',
              },
              '@media screen and (min-width: 901px) and (max-width: 1200px)': {
                fontSize: '7rem',
                marginTop: '-80px',
              }
            }}>
            Together
          </Typography>
        </Box>
        <Box sx={{
          borderTop: '4px solid #fd4002',
          marginTop: '-10px',
          backgroundColor: '#e5e8d9',
          height: '100px',
          zIndex: 2,
          position: 'relative',
          '@media screen and (max-width: 600px)': {
            marginTop: '-25px',
          }
        }}></Box>
      </Box>
      <Box sx={{
        // position: 'absolute', bottom: '60px', left: '50%', 
        display: 'flex', alignItems: 'center', gap: '40px', width: '100%', justifyContent: 'center'
      }}>
        <Link href={'mailto:zoomka.rus@mail.ru'}>
          <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
            <AlternateEmailIcon sx={{
              color: '#fd4002', fontSize: '2rem',
              '@media screen and (max-width: 600px)': {
                fontSize: '1rem',
              }
            }} />
            <Typography
              sx={{
                color: '#fd4002',
                fontSize: '1.2rem',
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.6rem',
                }
              }}>
              zoomka.rus@mail.ru
            </Typography>
          </Stack>
        </Link>
        <Link href={'https://t.me/zwibez'} target='_blank'>
          <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
            <TelegramIcon sx={{
              color: '#fd4002',
              fontSize: '2rem',
              '@media screen and (max-width: 600px)': {
                fontSize: '1rem',
              }
            }} />
            <Typography
              sx={{
                color: '#fd4002',
                fontSize: '1.2rem',
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.6rem',
                }
              }}>
              @zwibez
            </Typography>
          </Stack>
        </Link>
        <Link href={'https://github.com/zoomkaz'} target='_blank'>
          <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
            <GitHubIcon sx={{
              color: '#fd4002',
              fontSize: '2rem',
              '@media screen and (max-width: 600px)': {
                fontSize: '1rem',
              }
            }} />
            <Typography
              sx={{
                color: '#fd4002',
                fontSize: '1.2rem',
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.6rem',
                }
              }}>
              zoomkaz
            </Typography>
          </Stack>
        </Link>
      </Box>
    </Box>
  )
}

export default Last